var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between" },
      [
        _vm.requiredFileType
          ? _c(
              "h6",
              [
                _vm._v(" Tipo de archivo requerido: "),
                _c(
                  "b-badge",
                  { staticClass: "ml-2", attrs: { variant: "primary" } },
                  [_vm._v(" " + _vm._s(_vm.requiredFileType) + " ")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.acceptedFileExtensionsArray.length
          ? _c(
              "h6",
              [
                _vm._v(" Extensiones permitidas: "),
                _vm._l(_vm.acceptedFileExtensionsArray, function(extension) {
                  return _c(
                    "b-badge",
                    {
                      key: extension,
                      staticClass: "ml-2",
                      attrs: { variant: "primary" }
                    },
                    [_vm._v(" " + _vm._s(extension) + " ")]
                  )
                })
              ],
              2
            )
          : _c("div"),
        _c(
          "b-button",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.tooltip,
                expression: "tooltip"
              }
            ],
            staticClass: "badge-glow mb-2",
            attrs: {
              "data-cy": "select-document",
              variant: _vm.disabled ? "warning" : "success",
              size: "sm",
              disabled: _vm.disabled
            },
            on: {
              click: function($event) {
                return _vm.onClick()
              }
            }
          },
          [
            _c("feather-icon", { attrs: { icon: "CheckIcon", size: "16" } }),
            _vm._v(" Seleccionar ")
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }